import {getLink} from '@/rest/payments/get-link';
import {EventFormMode} from '@/types/event';

export const handleOnboarding = async (
  mode: EventFormMode,
  eventId?: string
) => {
  try {
    const baseUrl = `${window.location.origin}/onboarding-redirect/${mode}`;
    const refreshUrl = eventId ? `${baseUrl}/${eventId}` : baseUrl;
    const returnUrl = eventId ? `${baseUrl}/${eventId}` : baseUrl;

    const response = await getLink('account_onboarding', refreshUrl, returnUrl);
    const onboardingLink = response.url;

    if (onboardingLink) {
      window.location.href = onboardingLink;
    } else {
      throw new Error('Failed to retrieve onboarding link');
    }
  } catch (error) {
    console.error('Failed to retrieve onboarding link', error);
    throw new Error('Failed to retrieve onboarding link');
  }
};
